export default function TextAreaField({item}){
    return (
        <div className={`w-full`}>
            <div className={`text-13`}>{item.label}</div>
            <textarea onKeyUp={ (e) => {
                item.value = e.target.value;
            } } defaultValue={item.value} className={`w-full min-h-[120px]`}></textarea>
        </div>
    )
}